// Tarjetas Visa

const latam = {
  regional: [
    {
      title: 'Acumulá 1 milla cada 2 dólares o el equivalente en pesos gastados en compras',
      icon: 'plane',
      content: [
        `LATAM Pass es el programa de pasajero frecuente de LATAM Airlines creado para premiar la preferencia y lealtad de sus pasajeros.
        <br />
        <br />
        Los socios del programa LATAM Pass acumulan millas cada vez que vuelan en LATAM Airlines o en cualquiera de sus aerolíneas asociadas. Además, acumulan millas en el día a día pagando las compras con su tarjeta de crédito Itaú Visa LATAM Pass.
        <br />
        <br />
        Las millas te sirven para canjear por pasajes en vuelos de LATAM Airlines o productos que prefieras del catálogo LATAM Pass.
        <br />
        <br />
        <a href="https://latampass.latam.com/es_uy/canjea-tus-millas" target="_blank">Conoce más</a>
        `,
      ],
    },
    {
      title: 'Primera adicional sin cargo',
      icon: 'plusone',
      content: [
        'La primera adicional es sin cargo. A partir de la segunda adicional se cobra el 50% del costo de la tarjeta.',
      ],
    },
    {
      title: 'Tipo de emisión',
      icon: 'document',
      content: [
        `La tarjeta Visa Regional tiene un tipo de emisión automática. Esto significa que simplemente completando el formulario de solicitud, <b>nuestro sistema validará automáticamente tu tarjeta sin que tengas que presentar documentación ni recibos de sueldo.</b> Si tus datos validan con nuestro sistema, tu tarjeta queda aprobada y te la enviamos en 48 horas sin moverte de tu casa.`,
      ],
    },
    {
      title: 'Crédito',
      icon: 'more',
      content: [
        'El límite de crédito será definido según nuestras políticas, y está sujeto a aprobación crediticia.',
      ],
    },
    {
      title: 'Bono de millas',
      icon: 'star',
      content: [
        `Bono de bienvenida de 3.500 millas LATAM Pass para tarjetas nuevas cuando se realice la primera compra. El bono se acredita junto con las millas generadas en el primer estado de cuenta.
        <br />
        <br />
        ** Bono anual de 1.500 millas LATAM Pass que se acredita en enero al llegar a 3.000 millas en el año calendario por consumos.`,
      ],
    },
    {
      title: 'Millas por consumo',
      icon: 'cart',
      content: [
        `Cada 2 dólares de consumo, generás 1 milla.
        <br />
        <br />
        Todos los consumos que realices con tu Visa LATAM Pass Internacional generará millas LATAM a excepción de los retiros de dinero en efectivo, cargos por intereses o cargos por parte del Banco (comisiones), ni consumos realizados en redes de cobranza (Abitab y RedPagos).`,
      ],
    },
    {
      title: 'Vencimiento de las millas LATAM Pass',
      icon: 'document',
      content: [
        'Las millas LATAM Pass tienen una vigencia de 36 meses, que podés renovar por 36 meses más al acumular 5.000 millas LATAM Pass en un año.',
      ],
    },
    {
      title: 'Puntos calificables',
      icon: 'cart',
      content: [
        `Acumulá 1 punto calificable por cada 2 millas acumuladas. Estos puntos sirven para subir o mantener tu categoría Elite dentro del programa LATAM Pass.
        <br />
        <br />
        <a href="https://latampass.latam.com/es_uy/categorias-elite/puntos-calificables" target="_blank">Conoce más</a>`,
      ],
    },
  ],
  internacional: [
    {
      title: 'Acumulá 1 milla cada 2 dólares o el equivalente en pesos gastados en tus compras',
      icon: 'plane',
      content: [
        `LATAM Pass es el programa de pasajero frecuente de LATAM Airlines creado para premiar la preferencia y lealtad de sus pasajeros.
        <br />
        <br />
        Los socios del programa LATAM Pass acumulan millas cada vez que vuelan en LATAM Airlines o en cualquiera de sus aerolíneas asociadas. Además, acumulan millas en el día a día pagando las compras con su tarjeta de crédito Itaú Visa LATAM Pass.
        <br />
        <br />
        Las millas te sirven para canjear por pasajes en vuelos de LATAM Airlines o productos que prefieras del catálogo LATAM Pass.
        <br />
        <br />
        <a href="https://latampass.latam.com/es_uy/canjea-tus-millas" target="_blank">Conoce más</a>`,
      ],
    },
    {
      title: 'Primera adicional sin cargo',
      icon: 'plusone',
      content: [
        'La primera adicional es sin cargo. A partir de la segunda adicional se cobra el 50% del costo de la tarjeta.',
      ],
    },
    {
      title: 'Tipo de emisión',
      icon: 'document',
      content: [
        `La tarjeta Visa Internacional tiene un tipo de emisión automática. Esto significa que simplemente completando el formulario de solicitud, <b>nuestro sistema validará automáticamente tu tarjeta sin que tengas que presentar documentación ni recibos de sueldo.</b> Si tus datos validan con nuestro sistema, tu tarjeta queda aprobada y te la enviamos en 48 horas sin moverte de tu casa.`,
      ],
    },
    {
      title: 'Crédito',
      icon: 'money-circle',
      content: [
        'El límite de crédito será definido según nuestras políticas, y está sujeto a aprobación crediticia.',
      ],
    },
    {
      title: 'Bono de millas',
      icon: 'star',
      content: [
        `Bono de bienvenida de 2.500 millas LATAM Pass para tarjetas nuevas cuando se realice la primera compra. El bono se acredita junto con las millas generadas en el primer estado de cuenta.`,
      ],
    },
    {
      title: 'Millas por consumo',
      icon: 'more',
      content: [
        `Cada 2 dólares de consumo, generás 1 milla.
        <br />
        <br />
        Todos los consumos que realices con tu Visa LATAM Pass Internacional generará millas LATAM a excepción de los retiros de dinero en efectivo, cargos por intereses o cargos por parte del Banco (comisiones), ni consumos realizados en redes de cobranza (Abitab y RedPagos).`,
      ],
    },
    {
      title: 'Vencimiento de las millas LATAM Pass',
      icon: 'document',
      content: [
        'Las millas LATAM Pass tienen una vigencia de 36 meses, que podés renovar por 36 meses más al acumular 5.000 millas LATAM Pass en un año.',
      ],
    },
    {
      title: 'Puntos calificables',
      icon: 'cart',
      content: [
        `Acumulá 1 punto calificable por cada 2 millas acumuladas. Estos puntos sirven para subir o mantener tu categoría Elite dentro del programa LATAM Pass.
        <br />
        <br />
        <a href="https://latampass.latam.com/es_uy/categorias-elite/puntos-calificables" target="_blank">Conoce más</a>`,
      ],
    },
  ],
  oro: [
    {
      title: '  Acumulá 1 milla cada 1 dólar o el equivalente en pesos gastados en tus compras  ',
      icon: 'plane',
      content: [
        ' LATAM Pass es el Programa de Pasajero Frecuente de LAN creado para premiar la preferencia y lealtad de sus pasajeros. ',
        'Los socios del Programa LATAM Pass acumulan millas cada vez que vuelan en LAN, en cualquiera de las líneas aéreas integrantes de Oneworld o en las líneas aéreas asociadas a LATAM Pass. Además, acumulan millas en el día a día pagando con su tarjeta de crédito Itaú Visa LATAM Pass.',
        ' Los socios canjean sus millas por pasajes para volar en LAN, Oneworld y líneas asociadas, por upgrade de categoría al volar en LAN o por pasajes y promociones de millas + dinero. ',
      ],
    },
    {
      title: 'Adicionales sin cargo',
      icon: 'plusone',
      content: [
        ' La primera adicional es sin cargo. Además también acumulan millas Itaú en la cuenta titular. ',
      ],
    },
    {
      title: 'Tipo de emisión',
      icon: 'document',
      content: [
        'La tarjeta Visa Oro Internacional requiere que nos envíes documentación. Esto significa que <strong>deberás que presentar documentación</strong> para que un vendedor se ponga en contacto contigo.',
      ],
    },
    {
      title: 'Crédito',
      icon: 'money-circle',
      content: [
        ' El mínimo es de $60.000. Este crédito puede aumentar automáticamente según lo que nos devuelva el sistema. Si tu ingreso es mayor a $60.000 tu crédito será mayor. ',
      ],
    },
    {
      title: 'Bono de 3.500 millas',
      icon: 'star',
      content: [
        ' Bono de 3.500 millas Itaú para tarjetas nuevas cuando se realice la primera compra. ',
      ],
    },
    {
      title: 'Seguros',
      icon: 'more',
      content: [
        'Por más información sobre seguros <a href="https://www.visa.com.uy/content/VISA/lac/spanishlanguagemaster/es_CO/home/pague-con-visa/tarjetas/credito/visa-gold.html">clic aquí</a>.',
      ],
    },
  ],
  platinum: [
    {
      title: 'Clientes preferenciales',
      icon: 'person',
      content: [
        'Itaú Visa Platinum LATAM Pass es una tarjeta con beneficios exclusivos con una muy amplia cobertura en viajes sin cargo adicional para el titular.',
      ],
    },
    {
      title: 'Salas VIP',
      icon: 'vip',
      content: [
        `Descargá la app de Visa Airport Companion, para acceder a salas VIP en los aeropuertos, presentando el código QR luego de seleccionar la sala vip.
        <br />
        <br />
        Disponés de 10 accesos a USD 10 cada uno en el año calendario.
        <br />
        <br />
        Las tarjetas adicionales Platinum también pueden ingresar descargando la app de Visa Airport Companion, y consumen de los 10 accesos a tarifa preferencial.
        <br />
        <br />
        Por encima de los 10 accesos la tarifa es de USD 32 cada ingreso`,
      ],
    },
    {
      title: 'Servicio de asistencia en viajes',
      icon: 'lock',
      content: [
        `<b>Cobertura brindada por AXA</b>
        <br />
        <br />
        Al comprar el pasaje de avión con tu Visa Platinum, recibirás de forma gratuita y en todo el mundo protección contra accidentes o emergencias médicas que ocurran fuera de tu país de residencia o del país donde se emitió tu tarjeta. La cobertura incluida es a través de AXA USA.
        <br />
        <br />
        El Servicio de Emergencia Médica Internacional te ofrece cobertura médica, hospitalaria y dental, válida para viajes internacionales de hasta 60 días consecutivos desde la fecha de salida de tu país de residencia. Para activar tu seguro es obligatorio generar el certificado de viaje antes de cada viaje elegible. Para ello precisas <a href="https://visabenefitslac.axa-assistance.us/benefits/I_D_UY/EMC_Emergency_Medical_Assistance_11" target="_blank">ingresar aquí</a>, crear un usuario y contraseña y completar la información solicitada. También podés hacerlo por la app Visa Benefits, previo registro con tu correo y contraseña.
        <br />
        <br />
        Para solicitar la asistencia a través de AXA deberás comunicarte con la central operativa correspondiente al lugar donde te encuentres, mediante cobro revertido. Hacé <a href="https://www.itau.com.uy/inst/aci/docs/Seguros%20AXA.pdf" target="_blank">clic aquí</a> para ver los números de teléfono.
        <br />
        <br />
        <b>Cobertura brindada por Universal Assistance</b>
        <br />
        <br />
        Por tener Visa Platinum, tenés incluido sin costo el servicio de asistencia de viaje en todo el mundo (excepto República Oriental del Uruguay) con Universal Assistance con una cobertura de hasta USD 15.000 por persona. El seguro te cubre a ti como titular de la tarjeta, cónyuges e hijos dependientes menores a 21 años.
        <br />
        <br />
        Prestaciones: Asistencia médica, odontológica, jurídica y localización de equipaje.
        <br />
        <br />
        Para solicitar la asistencia a través de Universal Assistance siempre deberás comunicarse con la central operativa correspondiente al lugar donde te encuentres, mediante cobro revertido. <a href="https://www.itau.com.uy/inst/aci/docs/condiciones_generales.pdf" target="_blank">Ver condiciones</a>
        <br />
        <br />
        (*) Los seguros de asistencia en viajes no son acumulables.`,
      ],
    },
    {
      title: 'Primera adicional sin cargo',
      icon: 'plusone',
      content: [
        'La primera adicional es sin cargo. A partir de la segunda adicional se cobra el 50% del costo de la tarjeta.',
      ],
    },
    {
      title: 'Tipo de emisión',
      icon: 'document',
      content: [
        'La tarjeta Visa Platinum LATAM Pass requiere que nos envíes documentación para aprobación de la solicitud.',
      ],
    },
    {
      title: 'Crédito',
      icon: 'money-circle',
      content: [
        'El mínimo es de $125.000. Este crédito puede aumentar automáticamente según lo que nos devuelva el sistema. Si tu ingreso es mayor a $125.000 tu crédito será mayor.',
      ],
    },
    {
      title: 'Bono de millas',
      icon: 'star',
      content: [
        `Bono de bienvenida de 3.500 millas LATAM Pass para tarjetas nuevas cuando se realice la primera compra. El bono se acredita junto con las millas generadas en el primer estado de cuenta.`,
      ],
    },
    {
      title: 'Upgrade de Cabina en vuelos LATAM Airlines',
      icon: 'more',
      content: [
        `3 Tramos anuales de cortesía para postular a un Upgrade de Cabina en vuelos dentro de Sudamérica + 1 Tramo anual de cortesía para postular a un Upgrade de Cabina en vuelos fuera de Sudamérica.
        <br />
        <br />
        <a href="https://latampass.latam.com/es_uy/upgrade-de-cabina" target="_blank">Conocé más</a>`,
      ],
    },
    {
      title: 'Acumulá 1 milla cada 1 dólar o el equivalente en pesos gastados en tus compras',
      icon: 'bonus',
      content: [
        `Cada 1 dólar de consumo, generás 1 milla.
        <br />
        <br />
        LATAM Pass es el programa de pasajero frecuente de LATAM Airlines creado para premiar la preferencia y lealtad de sus pasajeros.
        <br />
        <br />
        Los socios del programa LATAM Pass acumulan millas cada vez que vuelan en LATAM Airlines o en cualquiera de sus aerolíneas asociadas. Además, acumulan millas en el día a día pagando las compras con su tarjeta de crédito Itaú Visa LATAM Pass.
        <br />
        <br />
        Las millas te sirven para canjear por pasajes en vuelos de LATAM Airlines o productos que prefieras del catálogo LATAM Pass.
        <br />
        <br />
        <a href="https://latampass.latam.com/es_uy/canjea-tus-millas" target="_blank">Conocé más</a>`,
      ],
    },
    {
      title: 'Vencimiento de las millas LATAM Pass',
      icon: 'document',
      content: [
        'Las millas LATAM Pass tienen una vigencia de 36 meses, que podés renovar por 36 meses más al acumular 5.000 millas LATAM Pass en un año.',
      ],
    },
    {
      title: 'Puntos calificables',
      icon: 'plane',
      content: [
        `Acumulá 1 punto calificable por cada 2 millas acumuladas. Estos puntos sirven para subir o mantener tu categoría Elite dentro del programa LATAM Pass.
        <br />
        <br />
        <a href="https://latampass.latam.com/es_uy/categorias-elite/puntos-calificables" target="_blank">Conocé más</a>`,
      ],
    },
  ],
  infinite: [
    {
      title: 'Clientes preferenciales',
      icon: 'plane',
      content: [
        'Itaú Visa Infinite es la primera tarjeta de estas características en el Uruguay, pensada especialmente para clientes preferenciales.',
        'Brinda reconocimiento y prestigio mundial junto con los mejores beneficios y servicios disponibles en la industria de medios de pago. Ofrece una muy amplia cobertura en viajes sin cargo para el titular y el grupo familiar.',
      ],
    },
    {
      title: 'Priority Pass',
      icon: 'plusone',
      content: [
        'Los titulares de la tarjeta Visa Platinum e Infinite de Itaú reciben junto con ésta la tarjeta Priority Pass. La misma permite ser parte del programa independiente de acceso a salas VIP de aeropuertos más amplio del mundo.</p><p>La tarjeta Priority Pass te brinda 7 accesos gratis al año (calendario). A partir del octavo acceso, se cargará a la tarjeta de crédito del titular cada acceso adicional a USD 27.</p><p>Para ver la lista de Salas Vip adheridas y bases y condiciones hacé <a href="https://www.prioritypass.com/en/airport-lounges">click aquí</a>.',
      ],
    },
    {
      title: 'Servicio de asistencia médica en Viaje: Cobertura brindada por Universal Assistance',
      icon: 'document',
      content: [
        '<strong>Área de Cobertura:</strong> Todo el mundo (excepto la República Oriental del Uruguay).',
        '<strong>Beneficiarios:</strong> Tarjeta habientes, cónyuges e hijos dependientes menores de 21 años.',
        '<strong>Prestaciones:</strong> Asistencia Médica, Odontológica, Jurídica y Localización de Equipaje.',
        'Los beneficiarios cuentan con el Servicio de Asistencia en Viajes que brinda Universal Assistance de hasta USD 15.000 por persona.',
        'Para solicitar la asistencia a través de Universal Assistance siempre deberás comunicarse con la central operativa correspondiente al lugar donde te encuentres, mediante cobro revertido.',
        '<a target="_blank" href="https://www.itau.com.uy/inst/aci/docs/condiciones_generales.pdf">Ver condiciones</a>',
      ],
    },
    {
      title: 'Cobertura brindada por AXA USA',
      icon: 'money-circle',
      content:
        '<p>Además, si se abona el pasaje de avión con Itaú Visa Platinum, cuentan con la siguiente cobertura a través de AXA USA (*).<p>Asistencia en Viajes de hasta un máximo de USD 100.000 en todo el mundo.</p><p><strong>Beneficiarios:</strong> titular, cónyuge e hijos menores de 23 años.</p><p><strong>(*)</strong> Los seguros de Asistencia en Viajes no son acumulables.</p><p><strong>(**)</strong> Países firmantes del tratado Schengen.</p><p>Para solicitar la asistencia a través de AXA siempre deberás comunicarse con la central operativa correspondiente al lugar donde te encuentres, mediante cobro revertido. Hacé <a href="https://www.itau.com.uy/inst/aci/docs/Seguros%20AXA.pdf">click aquí</a> para ver los números de teléfono.</p>',
    },
    {
      title: 'Seguros',
      icon: 'more',
      content: [
        'Por más información sobre seguros <a target="_blank" href="https://www.visa.com.uy/pague-con-visa/tarjetas/credito/visa-infinite.html">clic aquí</a>.',
      ],
    },
    {
      title: 'Adicionales sin cargo',
      icon: 'plusone',
      content: [
        'La primera adicional es sin cargo. Además también acumulan millas Itaú en la cuenta titular.',
      ],
    },
    {
      title: 'Tipo de emisión',
      icon: 'document',
      content: [
        'La tarjeta Visa Volar Infinite requiere que nos envíes documentación. Esto significa que deberás que presentar documentación para que un vendedor se ponga en contacto contigo.',
      ],
    },
    {
      title: 'Bono de 3.500 millas',
      icon: 'star',
      content: [
        'Bono de 3.500 millas Itaú para tarjetas nuevas cuando se realice la primera compra.',
      ],
    },
    {
      title: 'Visa Luxury Hotel Collection',
      icon: 'more',
      content: [
        'Los clientes de Visa Infinite tienen acceso a un programa de beneficios exclusivos en los más prestigiosos hoteles del mundo.',
      ],
    },
    {
      title: 'Acumulá 1 milla cada 1 dólar o el equivalente en pesos gastados en tus compras',
      icon: 'more',
      content: [
        'Volar es el programa de Itaú creado para acumular millas y canjear por lo que más te guste. Es la única tarjeta que te permite acumular millas con todas tus compras para viajar a donde quieras, cuando quieras y en la aerolínea que quieras.</p><p>Este plan no limita la disponibilidad en vuelos.</p><p>Además las millas Itaú se podrán canjear por diferentes premios como ser electrónicos de alta gama, días de spa y turismo interno.</p><p><a href="https://www.itauvolar.com.uy/volar/">Ver catálogo de millas Volar</a>',
      ],
    },
  ],
};

export default latam;
